<!-- 货物信息 -->
<template>
    <div>
        <div class="searchFlex">
            <!-- HandBookList -->
            <el-form size="mini" ref="searchform" :model="searchform" label-width="100px" :inline="true" class="demo-form-inline">
                <el-form-item label="账册类型" style="margin-bottom: 0px !important">
                    <el-select v-model="searchform.type" placeholder="请选择账册类型" style="width: 100%;" clearable>
                        <el-option v-for="item in handBookTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="" style="margin-bottom: 0px !important">
                    <div class="toolbar">
                        <el-button type="primary" size="mini" @click="getListBy">查询</el-button>
                        <el-button type="success" size="mini" @click="addHandBook">新增</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div style="margin-right:10px;">
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <vxe-table :data="handBookList" ref="wmshandBookTable" id="wmshandBookTable" size="mini" :columns="columns" :column-config="{ resizable: true }" 
        :custom-config="customConfig"  :row-config="{ isCurrent: true /* 启用当前行高亮 */ }" highlight-current-row> 
            <vxe-column type="seq" width="50" align="center"></vxe-column>
            <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title" sortable>
                <template #default="{ row, column }">
                    <span v-if="column.field === 'isUse'"> 
                        <el-switch v-model="row.isUse" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" 
                        :inactive-value="0" @change="changeIsuse(row)"> </el-switch>
                    </span>
                    <span v-else> {{ row[column.field] }} </span>
                </template>
            </vxe-column>
        </vxe-table>
        <!-- 新增账册弹出框 -->
        <el-dialog title="新增账册" width="60%" :visible.sync="addHandBookVisible" :before-close="addHandBookClose" v-dialogDrag
        :close-on-click-modal="false"> 
            <el-form ref="addHandBookForm" :model="addHandBookForm" label-width="120px" size="mini" :rules="rules">
                <el-form-item label="账册编号" prop="bookNo">
                    <el-input v-model="addHandBookForm.bookNo"></el-input>
                </el-form-item>
                <el-form-item label="海关10位编码" prop="companyCode">
                    <el-input v-model="addHandBookForm.companyCode"></el-input>
                </el-form-item>
                <el-form-item label="账册名称" prop="bookName">
                    <el-input v-model="addHandBookForm.bookName"></el-input>
                </el-form-item>
                <el-form-item label="账册类型" prop="type">
                    <el-select v-model="addHandBookForm.type" placeholder="请选择账册类型" style="width: 100%;" clearable>
                        <el-option v-for="item in handBookTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属仓库" prop="ckName">
                    <el-select v-model="addHandBookForm.ckName" placeholder="请选择仓库" style="width: 100%;" clearable>
                        <el-option v-for="item in ckNameList" :key="item.name" :label="item.name" :value="item.name"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddHandBook('addHandBookForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'handBook',
    mixins: [userProfile],
    data() {
        return {
            handBookList:[],
            columns:[], // 列名
            searchform:{
                type:'',
            }, // 搜索条件
            addHandBookVisible:false,// 新增账册弹窗是否显示
            addHandBookForm:{
                bookNo: '',
                companyCode: '',
                bookName: '',
                type: '',
                ckName:'', // 仓库
            },// 新增账册数据
            handBookTypeList:[],// 账册类型
            ckNameList:[], // 仓库列表
            rules:{
                bookNo:[
                    { required: true, message: '请输入账册编号', trigger: 'blue' },
                ],
                companyCode:[
                    { required: true, message: '请输入海关10位编码', trigger: 'blue' },
                ],
                bookName:[
                    { required: true, message: '请输入账册名称', trigger: 'blue' },
                ],
                type:[
                    { required: true, message: '请选择所属类别', trigger: 'change' },
                ],
                ckName:[
                    { required: true, message: '请选择仓库', trigger: 'change' },
                ],
            },
        }
    },
    //组件创建
    created() {
        this.getHandBook()
        this.getListBy()
        this.getckNameList()
    },
    methods: {
        // 获取账册类型
        getHandBook(){
            this.$api.getDicList( { value:'Wms账册类型'} ).then(res =>{
                this.handBookTypeList = res
            })
        },
        // 获取仓库
        getckNameList(){
            this.$api.getInfo(  ).then(res =>{
               this.ckNameList = res
            })
        },
        getListBy(){
            const parms = {
                type:this.searchform.type
            }
            this.$api.wmsgetHandBook( parms ).then(res =>{
                this.columns = res.columns
                this.handBookList = res.tableData
            })
        },
        addHandBook(){
            this.addHandBookVisible = true
        },  
        // 关闭弹窗
        addHandBookClose(){
            this.addHandBookVisible = false
            this.$nextTick(()=>{
                this.$refs.addHandBookForm.resetFields();
            })
            this.addHandBookForm = {
                bookNo: '',
                companyCode: '',
                bookName: '',
                type: '',
                ckName:'',
            }
        },
        // 添加货物信息
        saveAddHandBook(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        bookNo: this.addHandBookForm.bookNo,
                        companyCode: this.addHandBookForm.companyCode,
                        bookName: this.addHandBookForm.bookName,
                        type: this.addHandBookForm.type,
                        ckName: this.addHandBookForm.ckName,
                    }
                    this.$api.wmsinsHandBook( params ).then(res =>{
                        this.$message({
                            message: '添加账册成功',
                            type: 'success'
                        });
                        this.addHandBookClose()
                        this.searchform.type = ''
                        this.getListBy()
                    })
                }
            })
        },
        // 改变状态
        changeIsuse(data){
            this.$api.wmschangeHandBookStatus( data.id ).then(res =>{
                this.$message({
                    message: '修改状态成功',
                    type: 'success'
                });
                this.getListBy()
            })
        },
    }
}
</script>
<style lang="css">
.searchFlex{
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items:center;
}
.margin_right_20{
    margin-right: 20px;
}
</style>